import ReactDropdown from 'rc-dropdown'
import { FC } from 'react'
import DotsSvg from '@/shared/assets/images/DotsThreeOutlineVertical.svg'

interface DropdownButtonProps {
    children: React.ReactNode
}

export const DropdownButton: FC<DropdownButtonProps> = ({ children }) => {
    const overlay = (
        <ul className='list-none bg-white border-color-dark [&>li:not(:last-child)]:border-b [&>li:not(:last-child)]:border-color-dark border rounded-xl overflow-hidden'>
            {children}
        </ul>
    )
    return (
        <ReactDropdown
            overlay={overlay}
            trigger={['click']}
        >
            <button className='w-8 h-8 rounded-full flex items-center justify-center hover:cursor-pointer hover:bg-black/5 transition text-color-dark border border-color-dark'>
                <DotsSvg width={20} height={20}/>
            </button>
        </ReactDropdown>
    )
}